import { LayerSetting, LayerSettingValue } from ".";

export interface EnumLayerSettingValue<T> extends LayerSettingValue<T> {
  key: string;
  label: string;
  value: T;
}

export type EnumLayerSettingProps<T> = {
  id: string;
  values: EnumLayerSettingValue<T>[];
  default: EnumLayerSettingValue<T>;
};

export class EnumLayerSetting<T> implements LayerSetting<T> {
  private props;

  constructor(props: EnumLayerSettingProps<T>) {
    this.props = props;
  }

  get id() {
    return this.props.id;
  }
  get default() {
    return this.props.default;
  }
  get values() {
    return this.props.values;
  }

  findValueByKey(key: string) {
    return this.values.find((it) => it.key === key);
  }
}
